import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

export default function FAQ({ items, testid = "faq" }) {
  const [open, setOpen] = useState(null);
  return (
    <div className="divide-y divide-line border-y border-line" data-testid={testid}>
      {items.map((f, i) => (
        <div key={i}>
          <button
            onClick={() => setOpen(open === i ? null : i)}
            data-testid={`${testid}-q-${i}`}
            className="flex w-full items-center justify-between gap-6 py-6 text-left"
          >
            <span className="text-base font-semibold tracking-tight md:text-lg">{f.q}</span>
            <ChevronDown size={18} className={`shrink-0 text-pop transition-transform duration-300 ${open === i ? "rotate-180" : ""}`} />
          </button>
          <AnimatePresence initial={false}>
            {open === i && (
              <motion.div
                initial={{ height: 0 }}
                animate={{ height: "auto" }}
                exit={{ height: 0 }}
                transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
                className="overflow-hidden"
              >
                <p className="pb-6 pr-10 text-sm leading-relaxed text-mut" data-testid={`${testid}-a-${i}`}>{f.a}</p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
}
